import { Card } from '@mui/material';

const UICard = Card;
export default UICard;
